import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

/**
 * Props:
 * - month: number (0-11)
 * - year: number
 * - saveFunction: (month: number, year: number) => void
 */
const MonthYearSelectorModal = ({ modalOpen, setModalOpen, month, year, saveFunction }) => {
	const [selectedDate, setSelectedDate] = useState(dayjs());

	useEffect(() => {
		if (month !== undefined && year !== undefined) {
			setSelectedDate(dayjs().month(month).year(year));
		}
	}, [month, year]);

	const handleSave = () => {
		const selectedMonth = selectedDate.month(); // 0-based
		const selectedYear = selectedDate.year();
		saveFunction(selectedMonth, selectedYear);
		setModalOpen(false);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Box></Box>
			<Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
				<DialogTitle>Select Month & Year</DialogTitle>
				<DialogContent>
					<DatePicker
						// label="Month & Year"
						views={["year", "month"]}
						value={selectedDate}
						onChange={(newValue) => setSelectedDate(newValue)}
						renderInput={(params) => <TextField {...params} fullWidth sx={{ mt: 1 }} />}
						slotProps={{
							popper: {
								sx: {
									maxHeight: "150px",
									// limits the year scroller height
									"& .MuiYearCalendar-root": {
										maxHeight: "150px",
										overflowY: "auto",
									},
									"& .MuiPaper-root": {
										maxHeight: "220px", // 👈 limit the paper content
									},
								},
							},
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setModalOpen(false)}>Cancel</Button>
					<Button onClick={handleSave} variant="contained">
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</LocalizationProvider>
	);
};

export default MonthYearSelectorModal;
